import { addDoc, collection, deleteDoc, doc, getDocs, orderBy, query, setDoc } from 'firebase/firestore';

import { db } from 'utils/firebaseConfig';
import type { CommitteeAssignment } from 'types/domain';

const COMMITTEE_COLLECTION = 'committeeAssignments';

const normalizeAssignment = (id: string, raw: Partial<CommitteeAssignment>): CommitteeAssignment => ({
  id,
  role: raw.role || '',
  contactId: Number(raw.contactId) || 0,
  memberId: Number(raw.memberId) || 0,
  order: Number(raw.order) || 0,
});

export const getCommitteeAssignments = async (): Promise<CommitteeAssignment[]> => {
  const committeeRef = collection(db, COMMITTEE_COLLECTION);
  const committeeQuery = query(committeeRef, orderBy('order', 'asc'));
  const querySnapshot = await getDocs(committeeQuery);

  return querySnapshot.docs.map((snapshot) =>
    normalizeAssignment(snapshot.id, snapshot.data() as Partial<CommitteeAssignment>)
  );
};

export const upsertCommitteeAssignment = async (
  payload: Omit<CommitteeAssignment, 'id'> & { id?: string }
): Promise<string> => {
  if (payload.id) {
    const assignmentRef = doc(db, COMMITTEE_COLLECTION, payload.id);
    await setDoc(
      assignmentRef,
      {
        role: payload.role,
        contactId: Number(payload.contactId),
        memberId: Number(payload.memberId),
        order: Number(payload.order) || 0,
      },
      { merge: true }
    );

    return payload.id;
  }

  const documentRef = await addDoc(collection(db, COMMITTEE_COLLECTION), {
    role: payload.role,
    contactId: Number(payload.contactId),
    memberId: Number(payload.memberId),
    order: Number(payload.order) || 0,
  });

  return documentRef.id;
};

export const removeCommitteeAssignment = async (assignmentId: string): Promise<void> => {
  await deleteDoc(doc(db, COMMITTEE_COLLECTION, assignmentId));
};
